import React from 'react';
import styled from 'styled-components';

import DottedArrowInfographic from './DottedArrowInfographic';
import DottedArrowInfographicItem from './DottedArrowInfographic/DottedArrowInfographicItem';
import { device } from 'js/config/style';

const MainContainer = styled.div`
margin: 30px auto;
padding: 20px;
overflow: hidden;
@media(max-width: ${device.laptop}) {
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.05);
}
`;

const ContentContainer = styled.div`
  @media(max-width: ${device.laptop}) {
    & {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
`;

const ImageStep = styled.img`
  min-width: 90px;
  @media(max-width: ${device.laptop}) {
    display: none;
  }
`;

const MobileImageStep = styled.img`
  min-width: 120px;
  @media(min-width: ${device.laptop}) {
    display: none;
  }
`

const TextContentWrapper = styled.p`
@media(max-width: ${device.laptop}) {
  & {
    text-align: center;
  }
}
`;

const buyerSteps = [
  {
    img: '/images/buyer-page-info-steps/step-1-enter-details.svg',
    text: 'Once you enter your shipping details, Seller will be notified',
  },
  {
    img: '/images/buyer-page-info-steps/step-2-seller-accepts.svg',
    text: 'Seller accepts your offer and ships the item.',
  },
  {
    img: '/images/buyer-page-info-steps/step-3-item-delivery.svg',
    text: 'The item is delivered to your doorstep and you have 24 hrs to verify the item',
  },
  {
    img: '/images/buyer-page-info-steps/step-4-post-verification.svg',
    text: 'The payment is sent to the seller only after you’ve verified the item',
  },
];

function BuyerFlowInfographic() {
  const elements = buyerSteps.map((item, index) =>(
    <ContentContainer key={index}>
      <ImageStep src={item.img} />
      <TextContentWrapper>{item.text}</TextContentWrapper>
      <MobileImageStep src={item.img} />
    </ContentContainer>
  ));
  return (
    <MainContainer>
      <DottedArrowInfographic elements={elements} />
    </MainContainer>
  );
}

export default BuyerFlowInfographic;